import { SortDirection } from '@app-types/blackroom-api';
import { MRT_SortingState } from 'mantine-react-table';

/**
 * Converts MRT_SortingState array to a typed sorter object
 * @param sorting - The MRT_SortingState array from the table
 * @param defaultSort - Optional default sort field and direction when no sorting is applied
 * @returns A typed sorter object with SortDirection values
 */
export function convertSortingToSorter<
  T extends Record<string, SortDirection | undefined>,
>(
  sorting: MRT_SortingState,
  defaultSort?: { field: keyof T; direction: SortDirection },
): T {
  const sorter = {} as T;

  // Apply default sort if no sorting is specified
  if (sorting.length === 0 && defaultSort) {
    (sorter as any)[defaultSort.field] = defaultSort.direction;
    return sorter;
  }

  // Convert sorting array to sorter object
  sorting.forEach((sortItem) => {
    const direction = sortItem.desc ? SortDirection.Desc : SortDirection.Asc;
    (sorter as any)[sortItem.id] = direction;
  });

  return sorter;
}

/**
 * Type-safe version for Resource sorter specifically
 */
export type ResourceSorter = {
  rank?: SortDirection;
  index?: SortDirection;
  name?: SortDirection;
  updatedAt?: SortDirection;
  createdAt?: SortDirection;
  archivedAt?: SortDirection;
};

/**
 * Converts MRT_SortingState array to ResourceSorter object
 * @param sorting - The MRT_SortingState array from the table
 * @returns A ResourceSorter object
 */
export function convertSortingToResourceSorter(
  sorting: MRT_SortingState,
): ResourceSorter {
  return convertSortingToSorter<ResourceSorter>(sorting, {
    field: 'rank',
    direction: SortDirection.Asc,
  });
}
